/**
 * Convenience function that calls [[Serializable.serialize]]
 * if needed, otherwise returning `message` directly.
 *
 * This function must only be called once on
 * `message`, after which only the return value may
 * be used. This is because [[Serialize.serialize]]
 * must only be called once.
 */
export function serializeMessage(message) {
    if (typeof message === "string" || message instanceof Uint8Array)
        return message;
    else
        return message.serialize();
}
//# sourceMappingURL=message.js.map